import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import { getTroopNameFromId } from "Utils/Common";
import { StringMap } from "./StringMap";
import { StringValue } from "./StringValue";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Boss Kill Advanced">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        <StringValue
          label={"Elite Boss selected for killing/summoning:"}
          value={
            task.taskstatusdetail &&
            task.taskstatusdetail.selectedeliteAlliBoss &&
            task.taskstatusdetail.selectedeliteAlliBoss.bossname
          }
        />
        {task.taskstatusdetail.killelitebosses && (
          <>
            <StringValue
              label={"Kill Elite Bosses Task Status:"}
              value={task.taskstatusdetail.killelitebossesstatus}
            />
            <StringValue
              label={"Total Elite bosses done:"}
              value={task.taskstatusdetail.totalebossesdone}
            />
            <StringValue
              label={"Time remaining for next Elite Hit:"}
              value={task.taskstatusdetail.timeremainingfornextehit}
            />
            <StringValue
              label={"Elite Mith hits refilled/selected:"}
              value={`${task.taskstatusdetail.emithhitsdone}/
          ${task.taskstatusdetail.mithhitelite}`}
            />
          </>
        )}
        {(task.taskstatusdetail.killnormalbosses ||
          task.taskstatusdetail.summonnormalbosses) && (
          <StringValue
            label={"Normal Boss selected for killing/summoning:"}
            value={task.taskstatusdetail.selectednormalAlliBoss}
          />
        )}
        {task.taskstatusdetail.killnormalbosses && (
          <>
            <StringValue
              label={"Kill Normal Bosses Task Status:"}
              value={task.taskstatusdetail.killnormalbossesstatus}
            />
            <StringValue
              label={
                <>
                  Total bosses hit
                  <br />
                  (hit does not guarantee that boss was defeated, that depends
                  <br /> on troops and heroes selected):
                </>
              }
              value={task.taskstatusdetail.totalbossesdone}
            />
            <StringValue
              label={"Time remaining for next Normal boss Hit:"}
              value={task.taskstatusdetail.timeremainingfornexthit}
            />
            <StringValue
              label={"Normal Mith hits done/selected:"}
              value={`${task.taskstatusdetail.mithhitsdone}/
            ${task.taskstatusdetail.mithhitnormal}`}
            />
          </>
        )}
        {(task.taskstatusdetail.killnormalbosses ||
          task.taskstatusdetail.killelitebosses) && (
          <>
            <StringValue
              label={"BossKill Hero"}
              value={task.taskstatusdetail.atkheroname}
            />
            <StringMap
              label={"BossKill Troops"}
              valueMap={task.taskstatusdetail.troopskiller}
              valueParser={(k, v) => (
                <>
                  {getTroopNameFromId(k)}: {v}
                </>
              )}
            />
            <StringValue
              label={"Pop Attack Runes for mins selected"}
              value={task.taskstatusdetail.popatkrunesformins}
            />
          </>
        )}
        {task.taskstatusdetail.summonelitebosses && (
          <>
            <StringValue
              label={"Summon Elite Bosses Task Status:"}
              value={task.taskstatusdetail.summonelitebossesstatus}
            />
            <StringValue
              label={"EStam used/Max EStam to use selected:"}
              value={`${task.taskstatusdetail.estamsused}/${
                task.taskstatusdetail.useestams
              }`}
            />
          </>
        )}
        {task.taskstatusdetail.summonnormalbosses && (
          <>
            <StringValue
              label={"Summon Normal Bosses Task Status:"}
              value={task.taskstatusdetail.summonnormalbossesstatus}
            />
            <StringValue
              label={"Stam used/Max Stam to use selected:"}
              value={`${task.taskstatusdetail.stamsused}/${
                task.taskstatusdetail.usestams
              }`}
            />
          </>
        )}
        {(task.taskstatusdetail.summonnormalbosses ||
          task.taskstatusdetail.summonelitebosses) && (
          <>
            <StringValue
              label={"BossSummon Hero"}
              value={task.taskstatusdetail.defheroname}
            />
            <StringMap
              label={"BossSummon Troops"}
              valueMap={task.taskstatusdetail.troopssummoner}
              valueParser={(k, v) => (
                <>
                  {getTroopNameFromId(k)}: {v}
                </>
              )}
            />
          </>
        )}
        <StringValue
          label={"Auto Unbox Troops?"}
          value={task.taskstatusdetail.unboxtroops}
        />
        <StatusSection task={task} />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
